import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
const NEWS = [{
  id: 4,
  tag: 'Evento',
  title: 'Reviva tres espacios destacados de la XI Semana Geomática Internacional',
  href: 'https://programatefos.com/reviva-tres-espacios-destacados-de-la-xi-semana-geomatica-internacional/',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/854a4ed8-1392-4567-b2eb-246d288f8371.jpg'
}, {
  id: 6,
  tag: 'OTL',
  title: 'Corporaciones participaron en la socialización nacional del modelamiento de Objetos Territoriales Legales (OTL) del sector bajo el estándar LADM-COL',
  href: 'https://programatefos.com/corporaciones-participaron-en-la-socializacion-nacional-del-modelamiento-de-objetos-territoriales-legales-otl-del-sector-bajo-el-estandar-ladm-col/',
  image: 'https://cdn.magicpatterns.com/uploads/47TPKDBrQByMTrV527Rc4a/principal.jpg'
}];
export function NewsGrid() {
  return <section id="noticias" className="py-16 md:py-20 px-4 md:px-8" data-id="element-314" data-mp="3vb5ki0kvqhq8">
      <div className="max-w-[1400px] mx-auto" data-id="element-315" data-mp="2xumtrwn56ncd">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-316" data-mp="2xtbpzwtp5fl9">
          <div data-id="element-317" data-mp="2svtcdt4qic6x">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-3" data-id="element-318" data-mp="2su8t4znvefod">
              Archivo
            </span>
            <h2 className="text-2xl md:text-3xl font-serif text-forest" data-id="element-319" data-mp="32lmlmnhemf80">
              Noticias y eventos
            </h2>
          </div>
          <a href="https://programatefos.com/" target="_blank" rel="noopener noreferrer" className="text-charcoal/70 hover:text-clay font-medium flex items-center gap-2 transition-colors text-sm" data-id="element-320" data-mp="2ewk8nsxptaju">
            Ver todas <ArrowUpRight size={16} data-id="element-321" data-mp="2nuvulhnmzk5y" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-322" data-mp="2iwuaquidzgtf">
          {NEWS.map((item, index) => <motion.a key={item.id} href={item.href} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="group flex flex-col focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-323" data-mp="356ivdi8cehh" data-mpi={index}>
              <div className="relative aspect-[4/3] overflow-hidden mb-4 bg-bone-dark" data-id="element-324" data-mp="35znsc3kbzbiw">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-325" data-mp="299okycfx2j1w" />
                <div className="absolute top-2 left-2 bg-bone/95 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-forest" data-id="element-326" data-mp="2db017rcwhrxf">
                  {item.tag}
                </div>
              </div>
              <h3 className="text-base md:text-lg font-serif text-forest leading-snug group-hover:text-clay transition-colors" data-id="element-327" data-mp="2n2mnqjuovdfh">
                {item.title}
              </h3>
            </motion.a>)}
        </div>
      </div>
    </section>;
}